import get from 'lodash/get';

import { getIdFrom } from 'zoomforth_codesbane_viewer/lib/id_utils.js';

import {
  SET_SHOULD_RENDER_AS_MOBILE,
  SET_IN_PAGE_SEARCH_VALUE,
  SET_IS_IN_PAGE_SEARCH_DISPLAYED,
  SET_IS_NEEDS_REFRESH_DISPLAYED,
  SET_SECTION_SELECTED_CONTENT,
  SET_APPLIED_TAG_IDS_BY_CATEGORY_ID_FOR_GRID_SECTION_FILTER,
  SET_ACCORDION_STATE_BY_SECTION_ID,
  SET_ACTIVE_TAB_ID
} from '../const/action_types.js';

export default (state = {}, action)=> {

  switch (action.type) {

  case 'SET_CURRENT_SUBPAGE':
  
    return {
      ...state,
      currentSubpageId: action.id,
      lastClickedSubmenuItemId: null,
      // we always want to clear the overlay when we set the subpage.
      activeOverlayContentUuid: null
    };

  case SET_IS_IN_PAGE_SEARCH_DISPLAYED:
    return {
      ...state,
      isInPageSearchDisplayed: action.isInPageSearchDisplayed
    };

  case SET_IS_NEEDS_REFRESH_DISPLAYED: 
    return {
      ...state,
      isNeedsRefreshDisplayed: action.isNeedsRefreshDisplayed
    };

  case SET_SHOULD_RENDER_AS_MOBILE: 
    return {
      ...state,
      shouldRenderAsMobile: action.shouldRenderAsMobile
    };

  case 'SET_LAST_CLICKED_SUBMENU_ITEM_ID':
    return {
      ...state,
      lastClickedSubmenuItemId: action.id
    };

  case 'SET_LAST_CLICKED_TOPLEVEL_INTERNAL_LINK_ID':
    return {
      ...state,
      lastClickedToplevelInternalLinkId: action.id
    };
    
  case 'SET_ACTIVE_OVERLAY_CONTENT':
    return {
      ...state,
      activeOverlayContentUuid: action.contentUuid,
      isOverlayOpenedFromSlideshow: action.isOverlayOpenedFromSlideshow
    };

  case SET_APPLIED_TAG_IDS_BY_CATEGORY_ID_FOR_GRID_SECTION_FILTER:
    return {
      ...state,
      appliedTagIdsByCategoryIdBySectionId: {
        ...state.appliedTagIdsByCategoryIdBySectionId,
        [action.sectionId]: action.tagIdsByCategoryId
      }
    };

  case 'SET_ALLOW_AUTOPLAY_FOR_CONTENT':
    return {
      ...state,
      sectionStateById: {
        [action.sectionId]: {
          ...state.sectionStateById[action.sectionId],
          allowAutoplayForContentUuid: action.contentUuid
        }
      }
    };

  case SET_IN_PAGE_SEARCH_VALUE:
    return {
      ...state,
      inPageSearchValue: action.value
    };

  case SET_SECTION_SELECTED_CONTENT:
    return {
      ...state,
      sectionStateById: {
        [action.section.id]: {
          ...state.sectionStateById[action.section.id],
          selectedContentUuid: action.contentUuid,
          // only allow autoplay for the content that has most recently
          // been selected via dispatch
          ...(action.allowAutoplay ? 
              { allowAutoplayForContentUuid: action.contentUuid }
            :
              {}
            )
        }
      }
    };

  case 'SET_SCROLLING_TO_SECTION': {
    
    const sectionId = action.section ? (action.section.id ? action.section.id : action.section) : null;
    return {
      ...state,
      scrollingToSectionId: sectionId,
      scrollAnimationTimeMs: action.animationTimeMs
    };
  }

  case 'SET_SCROLLING_TO_TOP': {
    return {
      ...state,
      isScrollingToTop: action.shouldScrollToTop,
      scrollAnimationTimeMs: action.animationTimeMs,
      lastClickedSubmenuItemId: null,
      lastClickedToplevelInternalLinkId: null
    };
  }

  case 'SET_SCROLLING_TO_TILE': {
    
    const contentUuid = action.contentItemOrUuid 
      ? (action.contentItemOrUuid.uuid ? action.contentItemOrUuid.uuid : action.contentItemOrUuid) 
      : null;
    return {
      ...state,
      scrollingToTileUuid: contentUuid,
      scrollAnimationTimeMs: action.animationTimeMs
    };
  }

  case 'SET_SCROLLING_TO_ACCORDION_ITEM': {
    
    const contentUuid = action.contentItemOrUuid 
      ? (action.contentItemOrUuid.uuid ? action.contentItemOrUuid.uuid : action.contentItemOrUuid) 
      : null;
    return {
      ...state,
      scrollingToAccordionItemUuid: contentUuid,
      scrollAnimationTimeMs: action.animationTimeMs
    };
  }

  case SET_ACCORDION_STATE_BY_SECTION_ID: {
    return {
      ...state,
      sectionStateById: {
        ...state.sectionStateById,
        [action.sectionId]: {
          ...state.sectionStateById[action.sectionId],
          openAccordionIndices: action.openIndices
        }
      }
    };
  }

  case SET_ACTIVE_TAB_ID: {
    return {
      ...state,
      activeTabIdBySectionId: {
        ...state.activeTabIdBySectionId,
        [action.sectionId]: action.tabId
      }
    };
  }

  default: {
    return state;
  }

  }
};

export const getOpenIndicesForAccordion = (state, sectionId)=>
  get(state.sectionStateById, `${sectionId}.openAccordionIndices`);

export const getActiveTabId = (state, sectionId) => {
  return state.activeTabIdBySectionId?.[sectionId] || null;
};

export const getActiveOverlayContentUuid = (state)=>
  state.activeOverlayContentUuid;

export const getIsActiveOverlayOpenedFromSlidehsow = (state)=>
  state.isOverlayOpenedFromSlideshow;

export const getCurrentSubpageId = (state)=>
  state.currentSubpageId;

export const getViewerType = (state)=>
  state.viewerType;

export const getLastClickedSubmenuItemId = (state)=>
  state.lastClickedSubmenuItemId;

export const getLastClickedToplevelInternalLinkId = (state)=>
  state.lastClickedToplevelInternalLinkId;

export const getSectionSelectedContentUuid = (state, sectionOrId)=> {
  const sectionId = getIdFrom(sectionOrId);
  const sectionState = state.sectionStateById[sectionId];
  if (!sectionState) {
    return null;
  }
  return sectionState.selectedContentUuid;
};

export const getSectionAllowAutoplayContentUuid = (state, sectionOrId)=> {
  const sectionId = getIdFrom(sectionOrId);
  const sectionState = state.sectionStateById[sectionId];
  if (!sectionState) {
    return false;
  }
  return sectionState.allowAutoplayForContentUuid;
};

export const getScrollingToSectionId = (state)=>
  state.scrollingToSectionId;

export const getScrollingToTileUuid = (state)=>
  state.scrollingToTileUuid;

export const getScrollingToAccordionItemUuid = (state)=>
  state.scrollingToAccordionItemUuid;

export const getInPageSearch = (state)=>
  state.inPageSearchValue || '';

export const getIsInPageSearchDisplayed = (state)=>
  !!state.isInPageSearchDisplayed;

export const getIsNeedsRefreshDisplayed = (state)=>
  !!state.isNeedsRefreshDisplayed;

export const getIsScrollingToTop = (state)=>
  state.isScrollingToTop;

export const getScrollingAnimationTimeMs = (state)=>
  state.scrollAnimationTimeMs;

export const getCustomFooterHtml = (state)=>
  state.customFooterHtml;

export const getUseFixedNavLinks = (state)=>
  state.useFixedNavLinks;

export const getAppliedTagIdsByCategoryIdForSection = (state, sectionOrId)=>
  state.appliedTagIdsByCategoryIdBySectionId[getIdFrom(sectionOrId)] || {};

export const getRenderAsMobile = (state)=>
  state.shouldRenderAsMobile;

export const getShouldRenderHeader = (state)=>
  state.shouldRenderHeader;

export const getShouldRenderNavigation = (state)=>
  state.shouldRenderNavigation;

export const getShouldRenderFooter = (state)=>
  state.shouldRenderFooter;

export const getPreviewCollaborationSettings = (state)=> {
  // In some intsances the ViewerUI state might not exist which would result in state here being null after this function is called from ../index.js
  return (state && state.previewCollaborationSettings) || { isEnabled: false };
}
